import Firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const config = {
  apiKey: "AIzaSyBFO0Mgm0rN1zYgIRvBtIqSGCO73kUn9bg",
  authDomain: "disbon-parkmint.firebaseapp.com",
  databaseURL: "https://disbon-parkmint.firebaseio.com",
  projectId: "disbon-parkmint",
  storageBucket: "disbon-parkmint.appspot.com",
  messagingSenderId: "946699932041"
};

Firebase.initializeApp(config)  

const db = Firebase.firestore();
const auth = Firebase.auth();
const currentUser = auth.currentUser;

const settings = {
  timestampsInSnapshots: true
};
db.settings(settings);

const Pessoas = db.collection('pessoas');
const Equipamento = db.collection('equipamento');
const UnidadesNegocios = db.collection('unidades_negocios');
const RegioesVendas = db.collection('regioes_vendas');
const Cidades = db.collection('cidades');
const CargosFuncoes = db.collection('cargo');
const TiposPessoas = db.collection('tipos_pessoas');
const TipoEquipamento = db.collection('tipo_equipamento');
const PessoaEquipamento = db.collection('pessoa_equipamento');
const Acoes = db.collection('acoes');

function gravaAcoes(acao, colecao, objeto, data, usuario) {
  Acoes.add({
    'acao': acao,
    'colecao': colecao,
    'objeto': objeto,
    'data': data,
    'usuario': usuario
  });
}


export {
  db, 
  auth,
  currentUser,
  Pessoas,
  Equipamento,
  UnidadesNegocios,
  RegioesVendas,
  Cidades,
  CargosFuncoes,
  TiposPessoas,
  TipoEquipamento,
  PessoaEquipamento,
  Acoes,
  gravaAcoes
}